module.exports = __webpack_public_path__ + "static/media/instructor_sample.b1b85989.svg";